import { Member, MemberPermissionType } from '@/types';

import { apiClient } from '../http';
import { toMemberMutationInput } from './resourceMutationPayloads';
import { createSanitizedResourceService } from './resources';

const base = createSanitizedResourceService<
    Member,
    ReturnType<typeof toMemberMutationInput>,
    ReturnType<typeof toMemberMutationInput>
>('/api/members', toMemberMutationInput, toMemberMutationInput);

export const memberService = {
    ...base,
    getActive: () => apiClient.get<Member>('/api/active/member'),
    searchTeamInviteCandidates: (query: string) =>
        apiClient.post<Member[], { query: string }>('/api/search/database/members/team/invite', { query }),
    updatePermission: (memberId: string, permission: MemberPermissionType) =>
        apiClient.put<Member, { permission: MemberPermissionType }>(`/api/members/${memberId}/permissions`, {
            permission,
        }),
};
